<template>
    <div id="login-bkg">
        <NavBar class="nav-bar"/>
        <v-layout class='login-inner-cont'>
            <v-flex xs12 sm6 lg4>
                <div class="lighten-3 white-text">
                    <v-form>
                      <h1 class="my-3 login-title">GPVS Portal</h1>
                        <v-layout>
                            <v-text-field
                                dark
                                v-model="email"
                                type="email"
                                label="Email"
                                autofocus
                                required
                            ></v-text-field>
                        </v-layout>
                        <v-layout>
                            <v-text-field
                                dark
                                v-model="password"
                                type="password"
                                label="Password"
                                required
                            ></v-text-field>
                        </v-layout>
<!--                        <v-btn dark depressed class="login-btn" type="submit" color="#fcb61a" height="47px" @click="login"><strong>Login</strong></v-btn>-->
                        <div class="login-btn-cont">
                          <div class="login-btn" @click="login">Login</div>
                        </div>
                    </v-form>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
  import {auth} from '../config/firebaseInit';
  import NavBar from "../components/NavBar";
  export default {
    name: 'login',
    components: {
        NavBar
    },
    data: function () {
      return {
        email: '',
        password: ''
      };
    },
    methods: {
      login: function (event) {
        auth.signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.$router.push({path: '/list'});
          }).catch(error => {
          alert(error.message);
        });
        event.preventDefault();
      }
    },
    mounted() {
        window.scrollTo(0, 0);
    }
  }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
  #login-bkg {
      background-color: black;
      height: 100%;
  }
  .login-inner-cont{
      padding: 10%;

  }
  .login-title {
      color: white;
      font-size: 40px;
      font-family: 'SSNicksonFour', sans-serif;
  }

  .login-btn-cont {
    display: flex;
    width: 100%;
  }

  .login-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 47px;
    border-radius: 24px;
    background-color: #e1a732;
    color: black;
    text-transform: uppercase;
    font-family: Lato-Bold, sans-serif;
    font-size: 15px;
    cursor: pointer;
    margin-top: 70px;

    &:hover {
      filter: brightness(110%);
    }
  }

    @media #{map-get($display-breakpoints, 'xs-only')} {
        .login-inner-cont{
            padding: 20% 10%;
        }

        .login-btn-cont {
          justify-content: center;
        }

        .login-btn {
          margin-top: 50px;
          justify-self: center;
        }

        .login-title {
            font-size: 24px;
        }

    }
</style>
